import React, { createContext, useState } from 'react'

interface IStepperContext {
  children: React.ReactNode
}

interface StepperContextProps {
  CURRENT_STEP: number
  // STEPS: any[]
  // TOTAL_STEPS: number
  DATA: Record<string, any>
  COMPLETED_STEPS: number[]
  ERROR_STEPS: number[]
  DISABLED_STEPS: number[]
  SET_CURRENT_STEP: (currentStep: number) => void
  // SET_TOTAL_STEPS: (totalSteps: number) => void
  // SET_STEPS: (steps: any[]) => void
  SET_DATA: (data: Record<string, any>) => void
  SET_COMPLETED_STEPS: (steps: number[]) => void
  SET_ERROR_STEPS: (steps: number[]) => void
  SET_DISABLED_STEPS: (steps: number[]) => void
  NEXT_STEP: () => void
  PREV_STEP: () => void
}

export const StepperContext = createContext<StepperContextProps>({} as StepperContextProps)

export function StepperProvider({ children }: IStepperContext) {
  const [CURRENT_STEP, SET_CURRENT_STEP] = useState(0)
  //const [TOTAL_STEPS, SET_TOTAL_STEPS] = useState(0)
  //const [STEPS, SET_STEPS] = useState<number[]>([])
  const [COMPLETED_STEPS, SET_COMPLETED_STEPS] = useState<number[]>([])
  const [ERROR_STEPS, SET_ERROR_STEPS] = useState<number[]>([])
  const [DISABLED_STEPS, SET_DISABLED_STEPS] = useState<number[]>([])
  const [DATA, SET_DATA] = useState<any>({})

  const NEXT_STEP = () => {
    SET_CURRENT_STEP((prev) => prev + 1)
    //SET_CURRENT_STEP((prev) => Math.min(prev + 1, TOTAL_STEPS - 1))
  }

  const PREV_STEP = () => {
    SET_CURRENT_STEP((prev) => prev - 1)
    //SET_CURRENT_STEP((prev) => Math.max(prev - 1, 0))
  }

  return (
    <StepperContext.Provider value={
      {
        CURRENT_STEP,
        // TOTAL_STEPS,
        // STEPS,
        DATA,
        COMPLETED_STEPS,
        ERROR_STEPS,
        DISABLED_STEPS,
        SET_CURRENT_STEP,
        // SET_TOTAL_STEPS,
        // SET_STEPS,
        SET_DATA,
        SET_COMPLETED_STEPS,
        SET_ERROR_STEPS,
        SET_DISABLED_STEPS,
        NEXT_STEP,
        PREV_STEP,
      }
    }>
      {children}
    </StepperContext.Provider>
  )
}